const state = () => ({
  activeCurrency: "USD",
})

const mutations = {
  SET_ACTIVE_CURRENCY: (state, currency) => {
    state.activeCurrency = currency
  },
}

const actions = {
  setActiveCurrency: ({ commit }, currency) => {
    commit("SET_ACTIVE_CURRENCY", currency)
  },
}

const getters = {
  activeCurrency: state => state.activeCurrency,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/user/payment/payment.module.js